import * as React from 'react';
import FormHelperText from '@material-ui/core/FormHelperText';

import Typography from '../typography';
import Box, { BoxProps } from '../box';
import { Divider } from './styled';


type FormTitleProps = {
	appearance?: 'default' | 'dashed';
	fullWidth?: boolean;
} & BoxProps;

const FormTitle: React.SFC<FormTitleProps> = (props) => {
	const {
		appearance,
		fullWidth,
		children,
		...rest
	} = props;
	const map = {
		'default': () => {
			return (
				<Typography.Text
					component='h6'
					width={fullWidth ? '100%' : 'auto'}
					display={fullWidth ? 'block' : 'inline-block'}
					fontWeight={500}
					fontSize={16}
					margin='0'
					marginBottom='20px'
					{...rest}>
					{children}
				</Typography.Text>
			);
		},
		'dashed': () => {
			return (
				<Box
					width='100%'
					display='flex'
					alignItems='center'
					margin='0'
					marginBottom='20px'>
					<Typography.Text
						flex='0 0 auto'
						component='h6'
						fontWeight={500}
						margin='0'
						textTransform='uppercase'
						{...rest}>
						{children}
					</Typography.Text>
					<Divider />
				</Box>
			);
		},
	};

	return map[appearance] ? map[appearance]() : map['default']();
}

FormTitle.displayName = 'FormTitle';
FormTitle.defaultProps = {
	appearance: 'default',
};

const FormHelpers = {
	FormTitle,
	FormLabel: FormHelperText,
};

export default FormHelpers;
